import {
  transformApiCompanyDetails,
  transformApiContactDetails,
  transformApiMessages,
  transformApiPersonalDetails,
  transformCompanyDetails,
  transformContactDetails,
  transformMessages,
  transformPersonalDetails,
} from './common.mapper';

import { ApiJobInformation, JobInformation } from '../interfaces/job-information.interface';

export function transformJobInformation(apiJobInformation: ApiJobInformation): JobInformation {
  return {
    ...transformPersonalDetails(apiJobInformation.personal_details),
    ...transformCompanyDetails(apiJobInformation.company_details),
    ...transformContactDetails(apiJobInformation.contact_details),
    ...transformMessages(apiJobInformation.messages),
  };
}

export function transformApiJobInformation(jobInformation: JobInformation): ApiJobInformation {
  return {
    personal_details: transformApiPersonalDetails(jobInformation),
    company_details: transformApiCompanyDetails(jobInformation),
    contact_details: transformApiContactDetails(jobInformation),
    messages: transformApiMessages(jobInformation),
  };
}
